// extracted by mini-css-extract-plugin
module.exports = {"root":"TrueQuality_root___uL_9","one":"TrueQuality_one__Z6JKg","two":"TrueQuality_two__BNgjb"};